var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 22.4C22.4 25.6 16.8 27.2 11.2 27.2C5.6 27.2 0 25.6 0 22.4C0 19.2 5.6 17.6 11.2 17.6C16.8 17.6 22.4 19.2 22.4 22.4Z",
    fill: "url(#paint0_radial_2395_6350)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2001 0C8.65402 0 6.21222 1.01143 4.41187 2.81177C2.61152 4.61212 1.6001 7.05392 1.6001 9.6C1.6001 11.9488 2.9489 14.4112 4.4913 16.4896C6.0593 18.6 7.9345 20.4576 9.2033 21.6208C9.74624 22.1245 10.4595 22.4044 11.2001 22.4044C11.9407 22.4044 12.654 22.1245 13.1969 21.6208C14.4657 20.4576 16.3425 18.6 17.9089 16.4896C19.4513 14.4112 20.8001 11.9488 20.8001 9.6C20.8001 7.05392 19.7887 4.61212 17.9883 2.81177C16.188 1.01143 13.7462 0 11.2001 0Z",
    fill: "#C946CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 9.60002C14.4 10.4487 14.0629 11.2626 13.4627 11.8628C12.8626 12.4629 12.0487 12.8 11.2 12.8C10.3513 12.8 9.53738 12.4629 8.93726 11.8628C8.33714 11.2626 8 10.4487 8 9.60002C8 8.75133 8.33714 7.9374 8.93726 7.33728C9.53738 6.73717 10.3513 6.40002 11.2 6.40002C12.0487 6.40002 12.8626 6.73717 13.4627 7.33728C14.0629 7.9374 14.4 8.75133 14.4 9.60002Z",
    fill: "url(#paint1_linear_2395_6350)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2395_6350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4 20.8) rotate(-10.3048) scale(17.8885 7.66651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#A3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2395_6350",
    x1: 8.3712,
    y1: 9.88322,
    x2: 11.704,
    y2: 13.3488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECBE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMark);
export default __webpack_public_path__ + "static/media/LocationMark.b58e77108b7be4aaa76557676518813f.svg";
export { ForwardRef as ReactComponent };